module.exports = __webpack_public_path__ + "img/nbus_10pDetail.738a044d.png";